// extracted by mini-css-extract-plugin
export var input = "SearchForm-module--input--8be1e";